import { NEVER, Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { MicrosoftPermission } from '@nimbus-library/features/graph/enums/graph-permission.enum';
import { IFeaturePermissionResolver } from '@nimbus-library/features/feature-permission/models/i-feature-permission-resolver';
import { IUserConsentProvider } from '@nimbus-library/features/feature-permission/models/i-user-consent.provider';
import { IAuthenticationService } from '@nimbus-library/features/authentication/services/i-authentication.service';
import { IPermissionService } from '@nimbus-library/features/feature-permission/services/contracts/i-permission.service';
import { GraphUserConsentProvider } from '@nimbus-library/features/graph/resolver/graph-user-consent.provider';

@Injectable()
export class GraphPermissionResolver implements IFeaturePermissionResolver<MicrosoftPermission> {
  public constructor(
    private readonly authenticationService: IAuthenticationService,
    private readonly permissionService: IPermissionService,
  ) {}

  public resolve$(permissions: MicrosoftPermission[]): Observable<boolean> {
    return this.authenticationService.isAuthenticated$.pipe(
      switchMap((isAuthenticated) =>
        isAuthenticated
          ? this.authenticationService.getApiToken$(
              false,
              permissions.map((p) => p.toLowerCase()),
            )
          : NEVER,
      ),
      map((apiToken) => {
        const tokenPermissions = apiToken ? apiToken.permissions : [];
        const comparablePermissions = permissions.map((p) => p.toLowerCase());

        return comparablePermissions.every((permission) => tokenPermissions.includes(permission));
      }),
      catchError((err) => of(false)),
    );
  }
  public getConsentLink(permissions: MicrosoftPermission[]): string {
    return this.permissionService.requestAdminConsentLink(permissions);
  }

  public getUserConsentProvider(): IUserConsentProvider {
    return new GraphUserConsentProvider(this.permissionService);
  }
}
